import { useMemo, useState } from "react";

export function Select({
  options = [],
  value,
  onChange,
  placeholder = "Select...",
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const safeOptions = useMemo(() => {
    return (options || [])
      .filter((o) => o !== undefined && o !== null)
      .map((o) => ({
        id: o?.id || o?.ID || "",
        name: o?.name || o?.NAME || o?.city || "",
      }))
      .filter((o) => o.id && o.name);
  }, [options]);

  const filtered = safeOptions.filter((o) =>
    o.name.toLowerCase().includes((search || "").toLowerCase())
  );

  const selectedLabel =
    safeOptions.find(
      (o) => String(o.name).toLowerCase() === String(value || "").toLowerCase()
    )?.name || value || placeholder;

  return (
    <div className="relative w-full">
      <div
        onClick={() => setOpen(!open)}
        className="w-full rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 px-3 py-2 text-sm cursor-pointer"
      >
        {selectedLabel}
      </div>

      {open && (
        <div className="absolute z-50 mt-1 w-full rounded-lg border dark:border-slate-700 bg-white dark:bg-slate-800 shadow">
          <div className="p-2 border-b dark:border-slate-700">
            <input
              type="text"
              placeholder="Search city..."
              className="w-full px-2 py-1 text-sm border dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 rounded outline-none"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="max-h-60 overflow-y-auto">
            {filtered.map((option) => (
              <div
                key={option.id}
                onClick={() => {
                  onChange(option.name);
                  setOpen(false);
                  setSearch("");
                }}
                className="px-3 py-2 text-sm text-slate-900 dark:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-700 cursor-pointer"
              >
                {option.name}
              </div>
            ))}

            {filtered.length === 0 && (
              <div className="px-3 py-2 text-sm text-slate-400 dark:text-slate-500">
                No results
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}